import { useValidationErrorsStore } from '@hero/components/providers/ValidationErrorsProvider';

function useValidateRules() {
  const { addErrors, reset } = useValidationErrorsStore();

  const validate = async (validations = []) => {
    let validationErrors = [];
    await Promise.all(
      validations.map(async validation => {
        try {
          await validation.rule.validate(validation.value, { abortEarly: false });
        } catch (error) {
          const allErrors = [...validationErrors, ...error.errors];
          const allUniqueErrors = allErrors.filter(
            (error, index, self) => index === self.findIndex(t => t.key === error.key)
          );
          validationErrors = allUniqueErrors;
        }
      })
    );

    if (validationErrors.length) {
      addErrors(validationErrors);
      return false;
    } else {
      reset();
      return true;
    }
  };

  return { validate };
}

export { useValidateRules };
